import React from 'react';
import { ArrowLeft, ExternalLink, MonitorSmartphone } from 'lucide-react';
import { externOeffnen } from '../services/externOeffnen';
import { appBasisAdresse } from '../services/appUmfang';

interface Props {
    /**
     * Adresse fuer den System-Browser. Ansichten haben keine eigene Adresse
     * (die Web-App merkt sich die Ansicht im sessionStorage, nicht in der
     * URL) — ohne Angabe oeffnet deshalb die Basisadresse der Web-App.
     */
    url?: string;
    /** Rueckweg wie der Zurueck-Knopf der Ansicht (Modul → Hub, sonst Dashboard). */
    onBack: () => void;
}

/**
 * Platzhalter im App-Modus fuer alles ausserhalb des Begehungsteils
 * (docs/android-app-plan.md 1.4, Vertrag E5). Erscheint an der Stelle der
 * Ansicht — auch wenn ein Link, eine Mitteilung oder ein gemerkter Zustand
 * dorthin fuehrt. Im Web wird er nie gerendert.
 *
 * Bewusst KEINE `fixed inset-0`-Flaeche: die Android-Zurueck-Taste haelt
 * solche Flaechen fuer Dialoge und bliebe hier stehen.
 */
export const NurImBrowser: React.FC<Props> = ({ url, onBack }) => {
    const ziel = url ?? appBasisAdresse(window.location.origin, window.location.pathname);

    return (
        <div data-glass-view="kein-zugriff" className="h-full overflow-y-auto flex items-center justify-center p-6 animate-fade-in">
            <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-center">
                <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center">
                    <MonitorSmartphone className="w-6 h-6 text-blue-600" />
                </div>
                <h2 className="text-lg font-bold text-slate-800">Nur im Browser verfügbar</h2>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    Die App enthält die Begehungen, das Dashboard und die Mitteilungen.
                    Dieser Bereich steht im Browser vollständig zur Verfügung.
                </p>
                <div className="mt-6 flex flex-col gap-2">
                    <button
                        type="button"
                        onClick={() => externOeffnen(ziel)}
                        className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-semibold px-4 py-3 transition-colors"
                    >
                        <ExternalLink className="w-4 h-4" />
                        Im Browser öffnen
                    </button>
                    <button
                        type="button"
                        onClick={onBack}
                        className="w-full inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 active:bg-slate-100 text-slate-700 text-sm font-semibold px-4 py-3 transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Zurück
                    </button>
                </div>
            </div>
        </div>
    );
};
